<template>
    <section>
        <ui-breadcrumb title="Update Profile" :items="['User', 'Profile', 'Update']"></ui-breadcrumb>
        <div class="content">
            <form class="mb-5" action="" method="POST" @submit.prevent="updateProfile">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="user-name">Name</label>
                            <input :class="{'is-invalid': formErrors.name}" id="user-name" type="text" class="form-control"
                                   placeholder="Your Name" v-model="user.name">
                            <div v-if="formErrors.name" :class="['invalid-feedback']" >{{formErrors.name[0]}}</div>
                        </div>
                        <div class="form-group">
                            <label for="user-email">Email</label>
                            <input :class="{'is-invalid': formErrors.email}" type="text" class="form-control" v-model="user.email" id="user-email"
                                   placeholder="Your Email..">
                            <div v-if="formErrors.email" :class="['invalid-feedback']" >{{formErrors.email[0]}}</div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Phone Number</label>
                            <vue-tel-input @oninput="onInput" :class="{'is-invalid': formErrors.phoneNumber}" v-model="user.phoneNumber" class="form-control" :preferredCountries="['ke', 'tz', 'ug']"></vue-tel-input>
                            <div v-if="formErrors.phoneNumber" :class="['invalid-feedback']" >{{formErrors.phoneNumber[0]}}</div>
                        </div>
                        <div class="form-group">
                            <label for="user-company">Company</label>
                            <input v-model="user.company" type="text" class="form-control" id="user-company" placeholder="Company Name">
                        </div>
                    </div>
                </div>
                <div class="float-right form-group">
                    <button type="submit" class="btn btn-primary">
                        <span class="si si-check">
                        </span>
                        Update Profile
                    </button>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import {APP_CONFIG} from "../../config";
    import VueTelInput from 'vue-tel-input';

    export default {
        name: "ProfileEdit",
        components: {
            'vue-tel-input': VueTelInput
        },
        data() {
            return {
                user: {},
                formErrors:[]
            }
        },
        beforeMount() {
            axios.get(APP_CONFIG.URL + 'user/profile')
                .then((response) => {
                    this.user = response.data.data;
                }).catch(() => {
            });
        },
        methods: {
            /**
             * @param {string} number
             * the phone number inputted by user, will be formatted along with country code
             *
             * @param {Boolean} isValid
             * @param {string} country
             */
            onInput({ number, isValid, country }) {
                this.user.phoneNumber = number;
            },

            updateProfile() {
                axios.put(APP_CONFIG.URL + 'user/profile', this.user).then(() => {
                    this.$notify({
                        type: 'success',
                        message: 'Changes to your profile were updated',
                        title: 'Profile Updated'
                    });
                    this.$store.commit('setAuthenticatedUser', {user: this.user});
                    this.$router.push('/users/profile');
                }).catch((error) => {
                    if(error.response && error.response.status === 422) {
                        this.formErrors =  error.response.data.errors;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>